import Rest from '../rest'

/******************************************************************************
 *  Auth2FA
 *****************************************************************************/

/**
 * @type {Auth2FA}
 */
export default class Auth2FA extends Rest {
    constructor () {
        super('/auth')
    }
    saveConfigurations(data) {
        return this.createV2('configurations', data)
    }
    
}